import { useEventWebsitePagesQuery } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';
import { isEventPageVisible } from '@shared/utils/pageVisibility';

export const useEventHasPage = (pageSlug: string) => {
  const { eventHandle } = useEventInfo();
  const eventPages = useEventWebsitePagesQuery({
    variables: { eventHandle: eventHandle ?? '' },
    batchMode: 'fast',
  });

  const page = eventPages.data?.eventByName?.pages.find(page => page.pageSlug === pageSlug);
  return isEventPageVisible(page?.visibility);
};
